import React, { useState, useEffect } from "react";
import axios from "axios";
import ShiftForm from "./ShiftForm";
import ShiftList from "./ShiftList";

const ShiftManagement = () => {
  const [shifts, setShifts] = useState([]);

  const loadShifts = async () => {
    try {
      const res = await axios.get("https://45.76.62.40/api/shifts/");
      setShifts(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load shifts");
    }
  };

  useEffect(() => {
    loadShifts();
  }, []);

  return (
    <div className="row">
      <div className="col-md-4">
        <ShiftForm onSuccess={loadShifts} />
      </div>
      <div className="col-md-8">
        <ShiftList shifts={shifts} />
      </div>
    </div>
  );
};

export default ShiftManagement;
